import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"; 
import { ENDPOINT } from "constants/variables";
import IconButton from '@mui/material/IconButton'; 
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem  from "@mui/material/MenuItem";
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import ContractSearchStores from "pages/contracts/editOrNewContract/ContractSearchStores"; 
import ContractSearchStoresAddresses from "pages/contracts/editOrNewContract/ContractSearchStoresAddress";
import ContractSearchStoresNimaAddresses from "pages/contracts/editOrNewContract/ContractSearchStoresNimaAddress";
import PropTypes from 'prop-types';

const initialPostalCodesToSelect = [{
    "id":0,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":0
}];

const initialDocumentIdToSelect = [{
    "id": 0,
    "documentid": "",
    "tradename": ""
}];

const initialNimaToSelect = [{
    "id":0,
    "nima":""
}];

const ContractCreateOrEditAutTras = ({formContract,setFormContract,setIsLoadingErrorData,errorsForm,setErrorsForm,validateFormContract,documentTypesToSelect,roadTypesToSelect,communityToSelect,expanded,optTypeToSelect}) => {
    const {t,i18n} = useTranslation(['listDataContracts']);
    const token = useSelector((state) => state.loginUser.token); 
    const roles = useSelector((state) => state.loginUser.roles);  
    const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
    const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
    const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
    const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
    const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
    const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
    const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
    const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
    const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
    const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
    const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 
    const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
    const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false); 
    const [showModalSearchStoresNimaAddress, setShowModalSearchStoresNimaAddress] = useState(false);          
    const dispatch = useDispatch();     
    const [postalCodeAutTrasToSelect,setPostalCodeAutTrasToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeAutTras, setFilteredpostalCodeAutTras] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeAutTras, setHighlightedIndexPostalCodeAutTras] = useState(-1); // Índice de la opción resaltada 
    const [documentIdAutTrasToSelect,setDocumentIdAutTrasToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredDocumentIdAutTras, setFilteredDocumentIdAutTras] = useState([]); // Opciones filtradas
    const [highlightedIndexDocumentIdAutTras, setHighlightedIndexDocumentIdAutTras] = useState(-1); // Índice de la opción resaltada 
    const [tradenameAutTrasToSelect,setTradenameAutTrasToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredTradenamedAutTras, setFilteredTradenamedAutTras] = useState([]); // Opciones filtradas
    const [highlightedIndexTradenamedAutTras, setHighlightedIndexTradenamedAutTras] = useState(-1); // Índice de la opción resaltada 
    const [autTrasNimaToSelect,setAutTrasNimaToSelect]= useState(initialNimaToSelect);  
    const [filteredAutTrasNima, setFilteredAutTrasNima] = useState([]); // Opciones filtradas
    const [highlightedIndexAutTrasNima, setHighlightedIndexAutTrasNima] = useState(-1); // Índice de la opción resaltada 
         
    const ddRefDocIdAutTras = useRef(null);
    const ddRefTradeAutTras = useRef(null);
    const ddRefNimaAutTras = useRef(null);
    const ddRefPostalAutTras = useRef(null);

    // Debounce helper
    const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
    };
    
    // Dentro del componente
    const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeAutTras([]);
            setHighlightedIndexPostalCodeAutTras(-1);
        return;
        }
        const filtered = postalCodeAutTrasToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeAutTras(filtered);
        setHighlightedIndexPostalCodeAutTras(0);
    }, 300); 

    const handleSelectPostalCodeAutTras = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
            ...formContract,
            aut_tras_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
            aut_tras_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            aut_tras_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
            aut_tras_province_id: postal.province_id || Number(DEFAULTPROVINCE)
        }));
        setFilteredpostalCodeAutTras([]);
        setHighlightedIndexPostalCodeAutTras(-1);
    }; 

    const handleKeyDownDPostalCodeAutTras = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeAutTras.length === 0 && formContract.aut_tras_postalcode_code.trim() === "") {
            setHighlightedIndexPostalCodeAutTras(postalCodeAutTrasToSelect);
            setHighlightedIndexPostalCodeAutTras(0);
        } else {
            setHighlightedIndexPostalCodeAutTras((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeAutTras.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex,ddRefPostalAutTras);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexPostalCodeAutTras((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid,ddRefPostalAutTras);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeAutTras >= 0) {
            if (highlightedIndexPostalCodeAutTras >= 0 && highlightedIndexPostalCodeAutTras < filteredpostalCodeAutTras.length) {
                handleSelectPostalCodeAutTras(filteredpostalCodeAutTras[highlightedIndexPostalCodeAutTras]);
            }
        } else if (event.key === "Escape") {
            const isValid = postalCodeAutTrasToSelect.some((postal) => {
                if (!postal || !postal.postalcode) return false; 
                const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.aut_tras_postalcode_code.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormContract((formContract) => ({
                ...formContract,
                aut_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
                aut_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
                aut_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                aut_tras_province_id: Number(DEFAULTPROVINCE)
            }));
        } 
        setFilteredpostalCodeAutTras([]);
        setHighlightedIndexPostalCodeAutTras(-1);
        }
    };

    // Dentro del componente
    const debouncedHandleSearchDocumentId = useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDocumentIdAutTras([]);
            setHighlightedIndexDocumentIdAutTras(-1);
            return;
        }
        const filtered = documentIdAutTrasToSelect
            .filter(store => store && store.documentid)
            .filter(store => {
            const documentid = store.documentid.toUpperCase();
            return documentid.includes(upperValue);
            })
            .slice(0, 20); // limitar resultados
        setFilteredDocumentIdAutTras(filtered);
        setHighlightedIndexDocumentIdAutTras(0);
    }, 300);
    const handleSelectDocumentIdOri = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
            ...formContract,
            aut_tras_documentid: store.documentid || "",
        }));
        setFilteredDocumentIdAutTras([]);
        setHighlightedIndexDocumentIdAutTras(-1);
    }; 
    const handleKeyDownDocumentIdAutTras = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredDocumentIdAutTras.length === 0 && formContract.aut_tras_documentid.trim() === "") {
            setFilteredDocumentIdAutTras(documentIdAutTrasToSelect);
            setHighlightedIndexDocumentIdAutTras(0);
        } else {
            setHighlightedIndexDocumentIdAutTras((prevIndex) => {
            const nextIndex = prevIndex < filteredDocumentIdAutTras.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex,ddRefDocIdAutTras);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexDocumentIdAutTras((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid,ddRefDocIdAutTras);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdAutTras >= 0) {
        if (highlightedIndexDocumentIdAutTras >= 0 && highlightedIndexDocumentIdAutTras < filteredDocumentIdAutTras.length) {
            handleSelectDocumentIdOri(filteredDocumentIdAutTras[highlightedIndexDocumentIdAutTras]);
        }
        } else if (event.key === "Escape") {
            const isValid = documentIdAutTrasToSelect.some((store) => {
                if (!store || !store.documentid) return false; 
                const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.aut_tras_documentid.toUpperCase();
                return normalizedStoreId === normalizedInputId;
            }); 
        if (!isValid) {
            setFormContract((formContract) => ({
            ...formContract,
            aut_tras_documentid: "",
            }));
        } 
        setFilteredDocumentIdAutTras([]);
        setHighlightedIndexDocumentIdAutTras(-1);
        }
    };

    // Dentro del componente
    const debouncedHandleSearchTradename= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredTradenamedAutTras([]);
            setHighlightedIndexTradenamedAutTras(-1);
        return;
        }
        const filtered = tradenameAutTrasToSelect
        .filter(store => store && store.tradename)
        .filter(store => {
            const tradename = store.tradename.toUpperCase();
            return tradename.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredTradenamedAutTras(filtered);
        setHighlightedIndexTradenamedAutTras(0);
    }, 300); 

    const handleSelectTradeNameAutTras = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
        ...formContract,
        aut_tras_tradename: store.tradename || "",
        aut_tras_documentid: store.documentid || formContract.aut_tras_documentid,
        
        }));
        setFilteredTradenamedAutTras([]);
        setHighlightedIndexTradenamedAutTras(-1);
    }; 

    const handleKeyDownTradenameAutTras = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredTradenamedAutTras.length === 0 && formContract.aut_tras_tradename.trim() === "") {
            setFilteredTradenamedAutTras(tradenameAutTrasToSelect);
            setHighlightedIndexTradenamedAutTras(0);
        } else {
            setHighlightedIndexTradenamedAutTras((prevIndex) => {
            const nextIndex = prevIndex < filteredTradenamedAutTras.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex,ddRefTradeAutTras);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexTradenamedAutTras((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid,ddRefTradeAutTras);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedAutTras >= 0) {
        if (highlightedIndexTradenamedAutTras >= 0 && highlightedIndexTradenamedAutTras < filteredTradenamedAutTras.length) {
            handleSelectTradeNameAutTras(filteredTradenamedAutTras[highlightedIndexTradenamedAutTras]);
        }
        } else if (event.key === "Escape") {
        const isValid = tradenameAutTrasToSelect.some((store) => {
            if (!store || !store.tradename) return false; 
            const normalizedTradeName = store.tradename.toUpperCase();
            const normalizedInputTradeName = formContract.aut_tras_tradename.toUpperCase();
            return normalizedTradeName === normalizedInputTradeName;
        }); 
        if (!isValid) {
            setFormContract((formContract) => ({
            ...formContract,
            aut_tras_tradename: "",
            }));
        } 
        setFilteredTradenamedAutTras([]);
        setHighlightedIndexTradenamedAutTras(-1);
        }
    }; 

    // Dentro del componente
    const debouncedHandleSearchAutTrasNima= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredAutTrasNima([]);
            setHighlightedIndexAutTrasNima(-1);
        return;
        }
        const filtered = autTrasNimaToSelect
        .filter(nt => nt && nt.nima)
        .filter(nt => {
            const nima = nt.nima.toUpperCase();
            return nima.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredAutTrasNima(filtered);
        setHighlightedIndexAutTrasNima(0);
    }, 300); 
    const handleSelectAutTrasNima = (nt) => {
        if (!nt) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
        ...formContract,
        aut_tras_nima: nt.nima || ""
        }));
        setFilteredAutTrasNima([]);
        setHighlightedIndexAutTrasNima(-1);
    }; 
    const handleKeyDownAutTrasNima = (event) => {
       if (event.key === "ArrowDown") {
            if (filteredAutTrasNima.length === 0 && formContract.aut_tras_nima.trim() === "") {
                const filtered = autTrasNimaToSelect.filter(nt => nt && nt.nima).slice(0, 20);
                setFilteredAutTrasNima(filtered);
                setHighlightedIndexAutTrasNima(0);
            } else {
                setHighlightedIndexAutTrasNima((prevIndex) => {
                    const nextIndex = prevIndex < filteredAutTrasNima.length - 1 ? prevIndex + 1 : prevIndex;
                    scrollToElement(nextIndex,ddRefNimaAutTras);
                    return nextIndex;
                });
            }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexAutTrasNima((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid,ddRefNimaAutTras);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexAutTrasNima >= 0) {
            if (highlightedIndexAutTrasNima >= 0 && highlightedIndexAutTrasNima < filteredAutTrasNima.length) {
                handleSelectAutTrasNima(filteredAutTrasNima[highlightedIndexAutTrasNima]);
            }
        } else if (event.key === "Escape") {
            const isValid = autTrasNimaToSelect.some((nt) => {
                if (!nt || !nt.nima) return false; 
                const normalizedPostalCodeId = nt.nima.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.aut_tras_nima.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormContract((formContract) => ({
                ...formContract, 
                aut_tras_nima: ""
            }));
        } 
        setFilteredAutTrasNima([]);
        setHighlightedIndexAutTrasNima(-1);
        }
    };

    // Función para desplazar el contenedor
    const scrollToElement = (index, ref) => {
        const dropdown = ref?.current;
        const item = dropdown?.children?.[index];
        if (item) item.scrollIntoView({ behavior: "smooth", block: "nearest" });
    };


    const handleBlur = useCallback((event) => {
            if (!event || !event.currentTarget) return;
        // Asegúrate de que no se cierra si haces clic en un elemento de la lista
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setFilteredpostalCodeAutTras([]);
            setHighlightedIndexPostalCodeAutTras(-1);
            setFilteredDocumentIdAutTras([]);
            setHighlightedIndexDocumentIdAutTras(-1);
            setFilteredTradenamedAutTras([]);
            setHighlightedIndexTradenamedAutTras(-1);  
            setFilteredAutTrasNima([]);
            setHighlightedIndexAutTrasNima(-1);  
        }
    }, []);

    const handleChangeSelectDocumentType_Aut_tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            aut_tras_documnettype_id:event.target.value
        }));
    };

    const handleBlurSelectDocumentType_Aut_tras = (e) => {
        handleChangeSelectDocumentType_Aut_tras(e);
    };
    
    const handleChangeSelectRoadType_Aut_tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            aut_tras_roadtype_id : event.target.value 
        }));
    };

    const handleBlurSelectRoadType_Aut_tras = (e) => {
        handleChangeSelectRoadType_Aut_tras(e);
        setErrorsForm(validateFormContract());
    };

    const handleChangeSelectCommunity_Aut_tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            aut_tras_community_id : event.target.value   
        }));
    };
    const handleBlurSelectCommunity_Aut_tras = (e) => {
        handleChangeSelectCommunity_Aut_tras(e);
        setErrorsForm(validateFormContract());
    };

    const handleChangeDataEditContract_Aut_tras = (e) => {
        const { name, value } = e.target;
        setFormContract(formContract => ({
          ...formContract,
          [name]: value,
        }));
    };

    const handleBlurDataEditContract_Aut_tras = (e) => {
        handleChangeDataEditContract_Aut_tras(e);
        setErrorsForm(validateFormContract());
    };
    
    const searchFormStore = (event) => {
        setShowModalSearchStores(true);
    };

    const searchFormStoreAddress = (event) => {
        setShowModalSearchStoresAddress(true);
    };

    const searchFormStoreNimaAddress = (event) => { 
        setShowModalSearchStoresNimaAddress(true);
    };
 
    const deleteDateAutTras = (event) => {
        setFormContract(formContract => ({
          ...formContract,
            aut_tras_store_id:0,
            aut_tras_documnettype_id: Number(DEFAULTTYPEOFDOCUMENT),
            aut_tras_documentid:"",
            aut_tras_tradename: "",
            aut_tras_name: "",
            aut_tras_contactname: "",
            aut_tras_nima: "",
            aut_tras_inscription: "",
            aut_tras_grnp:"",
            aut_tras_opt: 0,
            aut_tras_phone: "",
            aut_tras_email: "",
            aut_tras_roadtype_id: Number(DEFAULTROADTYE),
            aut_tras_street: "",
            aut_tras_country_id: Number(DEFAULTCOUNTRY),
            aut_tras_country_name:DEFAULTCOUNTRY_NAME,
            aut_tras_province_id: Number(DEFAULTPROVINCE),
            aut_tras_province_name:DEFAULTPROVINCE_NAME,
            aut_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            aut_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            aut_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            aut_tras_community_id: Number(DEFAULTCOMMUNITY),
            aut_tras_community_name: DEFAULTCOMMUNITY_NAME
        }));
        setErrorsForm(validateFormContract());
        setErrorsForm(errorsForm => ({
            ...errorsForm,
            aut_tras_store_id:"",
            aut_tras_documnettype_id:"",
            aut_tras_documentid:"",
            aut_tras_tradename: "",
            aut_tras_name: "",
            aut_tras_contactname: "",
            aut_tras_nima: "",
            aut_tras_inscription: "",
            aut_tras_grnp:"",
            aut_tras_opt: "",
            aut_tras_phone: "",
            aut_tras_email: "",
            aut_tras_roadtype_id: "",
            aut_tras_street: "",
            aut_tras_country_id: "",
            aut_tras_country_name: "",
            aut_tras_province_id: "",
            aut_tras_province_name: "",
            aut_tras_postalcode_id: "",
            aut_tras_postalcode_code: "",
            aut_tras_postalcode_name: "",
            aut_tras_community_id: "",
            aut_tras_community_name: ""
        }));
    };

    const deleteDataSteetAutTras = (event) => {
        setFormContract(formContract => ({
          ...formContract,
            aut_tras_roadtype_id: Number(DEFAULTROADTYE),
            aut_tras_street: "",
            aut_tras_country_id: Number(DEFAULTCOUNTRY),
            aut_tras_country_name:DEFAULTCOUNTRY_NAME,
            aut_tras_province_id: Number(DEFAULTPROVINCE),
            aut_tras_province_name:DEFAULTPROVINCE_NAME,
            aut_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            aut_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            aut_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            aut_tras_community_id: Number(DEFAULTCOMMUNITY),
            aut_tras_community_name: DEFAULTCOMMUNITY_NAME, 
            aut_tras_nima: "",
            aut_tras_inscription: "",
            aut_tras_grnp:"",
            aut_tras_opt: 0
        }));
        setErrorsForm(validateFormContract());
    };

    useEffect(() => {
        let isMounted = true;
        const fetchExistNumberDocument = async () => {
            try {
              const getData = await helpHttp().get2(ENDPOINT,`contract/getexiststorebynumberdocument/`,token,formContract.aut_tras_documentid.replace(/[.\-/\\|]/g, "").trim());
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData>0 && getData!==formContract.aut_tras_store_id){
                    fetchStoreNumberDocument();
                }
              }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
 
        const fetchStoreNumberDocument = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`contract/getstorebynumberdocumentpriority`,token,formContract.aut_tras_documentid.replace(/[.\-/\\|]/g, "").trim(),3);
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    if (getData!==undefined && getData!==null && getData!==""){
                        setFormContract(formContract => ({
                            ...formContract,
                            aut_tras_store_id: getData.store_id,
                            aut_tras_documnettype_id: (getData.documnettype_id===undefined 
                                                    || getData.documnettype_id===null  
                                                    || getData.documnettype_id===""
                                                    || getData.documnettype_id==="0"
                                                    || getData.documnettype_id===0)?
                                                    Number(DEFAULTTYPEOFDOCUMENT):getData.documnettype_id,
                            aut_tras_tradename: getData.tradename,
                            aut_tras_name: getData.name,
                            aut_tras_contactname: getData.contacperson,
                            aut_tras_nima: getData.nima_aut_tras,
                            aut_tras_inscription: getData.pygr_aut_tras,
                            aut_tras_grnp:getData.grnp_aut_tras,
                            aut_tras_opt: getData.opt_aut_tras,
                            aut_tras_phone: getData.phone,
                            aut_tras_email: getData.email, 
                            aut_tras_roadtype_id: (getData.roadtype_id===undefined 
                                                    || getData.roadtype_id===null  
                                                    || getData.roadtype_id===""
                                                    || getData.roadtype_id==="0"
                                                    || getData.roadtype_id===0)?
                                                    Number(DEFAULTROADTYE):getData.roadtype_id,
                            aut_tras_street: getData.street,  
                            aut_tras_country_id: (getData.country_id===undefined 
                                                    || getData.country_id===null  
                                                    || getData.country_id===""
                                                    || getData.country_id==="0"
                                                    || getData.country_id===0)?
                                                    Number(DEFAULTCOUNTRY):getData.country_id,
                            aut_tras_country_name: (getData.country_name===undefined 
                                                    || getData.country_name===null  
                                                    || getData.country_name==="" )?
                                                    DEFAULTCOUNTRY_NAME:getData.country_name,
                            aut_tras_province_id: (getData.province_id===undefined 
                                                    || getData.province_id===null  
                                                    || getData.province_id===""
                                                    || getData.province_id==="0"
                                                    || getData.province_id===0)?
                                                    Number(DEFAULTPROVINCE):getData.province_id,
                            aut_tras_province_name: (getData.province_name===undefined 
                                                    || getData.province_name===null  
                                                    || getData.province_name==="" )?
                                                    DEFAULTPROVINCE_NAME:getData.province_name, 
                            aut_tras_postalcode_id: (getData.postalcode_id===undefined 
                                                        || getData.postalcode_id===null  
                                                        || getData.postalcode_id===""
                                                        || getData.postalcode_id==="0"
                                                        || getData.postalcode_id===0)?
                                                        Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id,
                            aut_tras_postalcode_code: (getData.postalcode_code===undefined 
                                                        || getData.postalcode_code===null  
                                                        || getData.postalcode_code==="" )?
                                                         DEFAULTPOSTALCODE_CODE:getData.postalcode_code,
                            aut_tras_postalcode_name:   (getData.postalcode_name===undefined 
                                                        || getData.postalcode_name===null  
                                                        || getData.postalcode_name==="" )?
                                                         DEFAULTPOSTALCODE_NAME:getData.postalcode_name,                       
                            aut_tras_community_id: (getData.community_id===undefined 
                                                        || getData.community_id===null  
                                                        || getData.community_id===""
                                                        || getData.community_id==="0"
                                                        || getData.community_id===0)?
                                                        Number(DEFAULTCOMMUNITY):getData.community_id,
                            aut_tras_community_name:   (getData.community_name===undefined 
                                                        || getData.community_name===null  
                                                        || getData.community_name==="" )?
                                                         DEFAULTCOMMUNITY_NAME:getData.community_name
                        }));
                        setErrorsForm(validateFormContract());
                    }  
                }         
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel3'){
            if (formContract.aut_tras_documentid && formContract.aut_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
                fetchExistNumberDocument();
            } 
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,expanded,formContract.aut_tras_documentid,errorsForm.aut_tras_documentid,setIsLoadingErrorData,DEFAULTCOMMUNITY,DEFAULTCOUNTRY,setFormContract,formContract.aut_tras_store_id,DEFAULTPROVINCE,setErrorsForm,validateFormContract,
        DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTTYPEOFDOCUMENT
    ]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataDocumentIdAutTras = async () => {
          try {
            const getData = await helpHttp().get2(ENDPOINT,`contract/getlistdocumentidcontracts/`,token,
              (formContract.aut_tras_documentid!==undefined && formContract.aut_tras_documentid!==null && formContract.aut_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.aut_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
              setDocumentIdAutTrasToSelect(getData); 
            }
          } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }
        };   
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel3'){
            if (formContract.aut_tras_documentid && formContract.aut_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataDocumentIdAutTras();
            }
        } else{
            setDocumentIdAutTrasToSelect(initialDocumentIdToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.aut_tras_documentid,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataTradenameAutTras = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlisttradenamecontracts/`,token,
                    (formContract.aut_tras_tradename!==undefined && formContract.aut_tras_tradename!==null && formContract.aut_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.aut_tras_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setTradenameAutTrasToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel3'){
            if (formContract.aut_tras_tradename && formContract.aut_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataTradenameAutTras();
            }
        } else{
            setTradenameAutTrasToSelect(initialDocumentIdToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.aut_tras_tradename,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeAutTras = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlistpostalcodect/`,token,
                    (formContract.aut_tras_postalcode_code!==undefined && formContract.aut_tras_postalcode_code!==null && formContract.aut_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.aut_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeAutTrasToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel3'){
            if (formContract.aut_tras_postalcode_code && formContract.aut_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeAutTras();
            } 
        } else{
            setPostalCodeAutTrasToSelect(initialPostalCodesToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.aut_tras_postalcode_code,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormContract]);
    
     useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeAutTrasFiscal = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlistpostalcodect/`,token,
                    (formContract.aut_tras_postalcode_code_fiscal!==undefined && formContract.aut_tras_postalcode_code_fiscal!==null && formContract.aut_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.aut_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeAutTrasToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel3'){
            if (formContract.aut_tras_postalcode_code_fiscal && formContract.aut_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeAutTrasFiscal();
            } 
        } else{
            setPostalCodeAutTrasToSelect(initialPostalCodesToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.aut_tras_postalcode_code_fiscal,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormContract]);

    useEffect(() => {
        let isMounted = true; 
        const fetchDataNimaAutTras = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`searchct/getlistnimas`,token,formContract.aut_tras_store_id, 
                    (formContract.aut_tras_nima!==undefined && formContract.aut_tras_nima!==null && formContract.aut_tras_nima.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.aut_tras_nima.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setAutTrasNimaToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel3'){
            if (formContract.aut_tras_store_id && formContract.aut_tras_store_id!==null && formContract.aut_tras_store_id!=="" && formContract.aut_tras_store_id!=="0" && formContract.aut_tras_store_id!==0){
                fetchDataNimaAutTras(); 
            }else{
                setAutTrasNimaToSelect(initialNimaToSelect);
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract,expanded,setFormContract,formContract.aut_tras_store_id]);

    return(
    (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel3') &&
        <>
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_DocuentType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="aut_tras_documnettype_id"
                        name="aut_tras_documnettype_id"
                        value={ (formContract.aut_tras_documnettype_id === undefined || formContract.aut_tras_documnettype_id ===null || formContract.aut_tras_documnettype_id ===""
                            || formContract.aut_tras_documnettype_id ==="0" || formContract.aut_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formContract.aut_tras_documnettype_id}
                        inputProps={{ style: {width: 200,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectDocumentType_Aut_tras}
                        onChange={handleChangeSelectDocumentType_Aut_tras}
                        helperText={errorsForm.aut_tras_documnettype_id!=null && errorsForm.aut_tras_documnettype_id!==""?t(errorsForm.aut_tras_documnettype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.aut_tras_documnettype_id === undefined || formContract.aut_tras_documnettype_id ===null || formContract.aut_tras_documnettype_id ===""
                                || formContract.aut_tras_documnettype_id ==="0" || formContract.aut_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formContract.aut_tras_documnettype_id
                        }}>
                        <option key={0} value=""/>
                        {documentTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.name}
                            </option>
                        ))}
                    </TextField>  
                    {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    <label className="text-primary" style={{ fontSize: 18}}>{t('Text_CONTRACT_CIF')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;  
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="aut_tras_documentid"
                            name="aut_tras_documentid"
                            value={formContract.aut_tras_documentid}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                ...prev,
                                aut_tras_documentid: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchDocumentId(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDocumentIdAutTras}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.aut_tras_documentid!=null?t(errorsForm.aut_tras_documentid):t('PlaceHolder_CONTRACT_CIF')}
                            placeholder={t('PlaceHolder_CONTRACT_CIF')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?283:323,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredDocumentIdAutTras.length > 0 && (
                            <div
                                ref={ddRefDocIdAutTras}
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "400px",
                                overflowY: "auto",
                                width: "250%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredDocumentIdAutTras.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectDocumentIdOri(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexDocumentIdAutTras ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexDocumentIdAutTras ? "white" : "black",
                                    }}
                                >
                                    {store.documentid} - {store.tradename}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>  
                    &nbsp;&nbsp;
                    <IconButton  size="small" className="deletesmall-select-button"   onClick={deleteDateAutTras}>
                        <DeleteIcon style={{fontSize: 28}}/>
                    </IconButton>
                    &nbsp;&nbsp;
                    {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                        <IconButton  size="small" className="edit-select-button" onClick={searchFormStore}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton> 
                    }
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_TRADENAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="aut_tras_tradename"
                            name="aut_tras_tradename"
                            value={formContract.aut_tras_tradename}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                    ...prev,
                                    aut_tras_tradename: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchTradename(e.target.value);
                            }}
                            onKeyDown={handleKeyDownTradenameAutTras}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.aut_tras_tradename!=null && errorsForm.aut_tras_tradename!==""?t(errorsForm.aut_tras_tradename):t('PlaceHolder_CONTRACT_TRADENAME')}
                            placeholder={t('PlaceHolder_CONTRACT_TRADENAME')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?858:834,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredTradenamedAutTras.length > 0 && (
                            <div
                                ref={ddRefTradeAutTras}
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "800px",
                                overflowY: "auto",
                                width: "150%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredTradenamedAutTras.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectTradeNameAutTras(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexTradenamedAutTras ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexTradenamedAutTras ? "white" : "black",
                                    }}
                                >
                                    {store.tradename} - {store.documentid}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_NAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_tras_name" 
                        name="aut_tras_name"
                        value={formContract.aut_tras_name}
                        inputProps={{ style: {width: i18n.language==='es'?812:857,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.aut_tras_name!=null && errorsForm.aut_tras_name!==""?t(errorsForm.aut_tras_name):t('PlaceHolder_CONTRACT_NAME')}
                        placeholder={t('PlaceHolder_CONTRACT_NAME')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Aut_tras}
                        onChange={handleChangeDataEditContract_Aut_tras} 
                    />
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_CONTACT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_tras_contactname" 
                        name="aut_tras_contactname"
                        value={formContract.aut_tras_contactname}
                        inputProps={{ style: {width: i18n.language==='es'?795:840,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.aut_tras_contactname!=null && errorsForm.aut_tras_contactname!==""?t(errorsForm.aut_tras_contactname):t('PlaceHolder_CONTRACT_CONTACT')}
                        placeholder={t('PlaceHolder_CONTRACT_CONTACT')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Aut_tras}
                        onChange={handleChangeDataEditContract_Aut_tras} 
                    />
                </div>
            </div> 
            <Typography style={{color:"#067330", fontSize: 16}} >  
                {t('Text_CONTRACT_ADDRESS')}
            </Typography>
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_RoadType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_tras_roadtype"
                        name="aut_tras_roadtype"
                        value={ (formContract.aut_tras_roadtype_id === undefined || formContract.aut_tras_roadtype_id ===null || formContract.aut_tras_roadtype_id ===""
                            || formContract.aut_tras_roadtype_id ==="0" || formContract.aut_tras_roadtype_id ===0)?Number(DEFAULTROADTYE):formContract.aut_tras_roadtype_id}
                        inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectRoadType_Aut_tras}
                        onChange={handleChangeSelectRoadType_Aut_tras}
                        helperText={errorsForm.aut_tras_roadtype_id!=null && errorsForm.aut_tras_roadtype_id!==""?t(errorsForm.aut_tras_roadtype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.aut_tras_roadtype_id === undefined || formContract.aut_tras_roadtype_id ===null || formContract.aut_tras_roadtype_id ===""
                                || formContract.aut_tras_roadtype_id ==="0" || formContract.aut_tras_roadtype_id ===0)?Number(DEFAULTROADTYE): formContract.aut_tras_roadtype_id
                        }}>
                        <option key={0} value=""/>
                        {roadTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_ADDRESS')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_tras_street" 
                        name="aut_tras_street"
                        value={formContract.aut_tras_street}
                        inputProps={{ style: {width: i18n.language==='es'?449:462,  fontSize: '18px', }, maxLength: 250 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.aut_tras_street!=null && errorsForm.aut_tras_street!==""?t(errorsForm.aut_tras_street):t('PlaceHolder_CONTRACT_ADDRESS')}
                        placeholder={t('PlaceHolder_CONTRACT_ADDRESS')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Aut_tras}
                        onChange={handleChangeDataEditContract_Aut_tras}
                    />
                </div>
                &nbsp;&nbsp;
                <IconButton  size="small" className="deletesmall-select-button" onClick={deleteDataSteetAutTras}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton>
                &nbsp;&nbsp;
                {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&& formContract.aut_tras_documentid!==undefined && formContract.aut_tras_documentid!=="") ?
                    <IconButton  size="small" className={`edit-${
                        (formContract.aut_tras_store_id===undefined
                        || formContract.aut_tras_store_id===""
                        || formContract.aut_tras_store_id==="0"
                        || formContract.aut_tras_store_id===0)
                        ? "noselect-button": "select-button" }`}
                        disabled={formContract.aut_tras_store_id===undefined
                        || formContract.aut_tras_store_id===""
                        || formContract.aut_tras_store_id==="0"
                        || formContract.aut_tras_store_id===0}
                        onClick={searchFormStoreAddress}>
                    <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>:
                    <IconButton  size="small" className="edit-noselect-button" disabled>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>
                }  
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_PostalCode')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="aut_tras_postalcode_code"
                            name="aut_tras_postalcode_code"
                            value={formContract.aut_tras_postalcode_code}
                            onChange={(e) => {
                                    setFormContract(prev => ({
                                    ...prev,
                                    aut_tras_postalcode_code: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchPostalCode(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDPostalCodeAutTras}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    const inputPostalCode = formContract.aut_tras_postalcode_code.trim().toUpperCase();
                                    const matchedPostal = postalCodeAutTrasToSelect.find((postal) => {
                                    const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                    return normalizedPostal === inputPostalCode;
                                    });

                                    if (matchedPostal) {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            aut_tras_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                            aut_tras_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                            aut_tras_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                            aut_tras_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE),
                                        }));
                                    } else {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            aut_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                            aut_tras_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                            aut_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                            aut_tras_province_id: Number(DEFAULTPROVINCE),
                                        }));
                                    }
                                    setFilteredpostalCodeAutTras([]);
                                    setHighlightedIndexPostalCodeAutTras(-1);
                                }
                            }}
                            label={errorsForm.aut_tras_postalcode_code!=null && errorsForm.aut_tras_postalcode_code!==""?t(errorsForm.aut_tras_postalcode_code):t('Text_CONTRACT_PostalCode')}
                            placeholder={t('Text_CONTRACT_PostalCode')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredpostalCodeAutTras.length > 0 && (
                            <div
                                ref={ddRefPostalAutTras}
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                width: "350%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredpostalCodeAutTras.map((postal, index) => (
                                <MenuItem
                                    key={postal.id}
                                    onClick={() => handleSelectPostalCodeAutTras(postal)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexPostalCodeAutTras ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexPostalCodeAutTras ? "white" : "black",
                                    }}
                                >
                                    {postal.postalcode} - {postal.name}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Locality')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_tras_postalcode_name" 
                        name="aut_tras_postalcode_name"
                        value={formContract.aut_tras_postalcode_name}
                        inputProps={{ style: {width: i18n.language==='es'?210:241,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.aut_tras_postalcode_name!=null && errorsForm.aut_tras_postalcode_name!==""?t(errorsForm.aut_tras_contactname):t('Text_CONTRACT_Locality')}
                        placeholder={t('Text_CONTRACT_Locality')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Aut_tras}
                        onChange={handleChangeDataEditContract_Aut_tras}
                        disabled
                    />  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Community')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_tras_community_id"
                        name="aut_tras_community_id"
                        value={ (formContract.aut_tras_community_id === undefined || formContract.aut_tras_community_id ===null || formContract.aut_tras_community_id ===""
                            || formContract.aut_tras_community_id ==="0" || formContract.aut_tras_community_id ===0)?Number(DEFAULTCOMMUNITY):formContract.aut_tras_community_id}
                        inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectCommunity_Aut_tras}
                        onChange={handleChangeSelectCommunity_Aut_tras}
                        helperText={errorsForm.aut_tras_community_id!=null  && errorsForm.aut_tras_community_id!==""?t(errorsForm.aut_tras_community_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.aut_tras_community_id === undefined || formContract.aut_tras_community_id ===null || formContract.aut_tras_community_id ===""
                                || formContract.aut_tras_community_id ==="0" || formContract.aut_tras_community_id ===0)?Number(DEFAULTCOMMUNITY): formContract.aut_tras_community_id
                        }}>
                        {communityToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>
                </div>
            </div> 
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Phone')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_tras_phone" 
                        name="aut_tras_phone"
                        value={formContract.aut_tras_phone}
                        inputProps={{ style: {width: 180,  fontSize: '18px', }, maxLength: 30 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}    
                        label={errorsForm.aut_tras_phone!=null && errorsForm.aut_tras_phone!==""?t(errorsForm.aut_tras_phone):t('PlaceHolder_CONTRACT_Phone')}
                        placeholder={t('PlaceHolder_CONTRACT_Phone')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Aut_tras}
                        onChange={handleChangeDataEditContract_Aut_tras}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Email')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="aut_tras_email" 
                        name="aut_tras_email"
                        value={formContract.aut_tras_email}
                        inputProps={{ style: {width: i18n.language==='es'?319:335 ,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}     
                        label={errorsForm.aut_tras_email!=null && errorsForm.aut_tras_email!==""?t(errorsForm.aut_tras_email):t('PlaceHolder_CONTRACT_Email')}
                        placeholder={t('PlaceHolder_CONTRACT_Email')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Aut_tras}
                        onChange={handleChangeDataEditContract_Aut_tras}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_NIMA')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="aut_tras_nima"
                            name="aut_tras_nima"
                            value={formContract.aut_tras_nima}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                ...prev,
                                aut_tras_nima: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchAutTrasNima(e.target.value);
                            }}
                            onKeyDown={handleKeyDownAutTrasNima}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.aut_tras_nima!=null && errorsForm.aut_tras_nima!==""?t(errorsForm.aut_tras_nima):t('PlaceHolder_CONTRACT_NIMA')}
                            placeholder={t('PlaceHolder_CONTRACT_NIMA')}
                            variant="standard"
                            inputProps={{ style: {width: 133,  fontSize: '18px'}, maxLength: 50 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredAutTrasNima.length > 0 && (
                            <div
                                ref={ddRefNimaAutTras}
                                className="dropdown-class"
                                style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    maxWidth: "750px",
                                    overflowY: "auto",
                                    width: "140%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredAutTrasNima.map((nt, index) => (
                                <MenuItem
                                    key={nt.id}
                                    onClick={() => handleSelectAutTrasNima(nt)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexAutTrasNima ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexAutTrasNima ? "white" : "black",
                                    }}
                                >
                                    {nt.nima}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;
                    {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formContract.aut_tras_documentid!==undefined && formContract.aut_tras_documentid!=="") ?
                        <IconButton  size="small" className={`edit-${
                            (formContract.aut_tras_store_id===undefined
                            || formContract.aut_tras_store_id===""
                            || formContract.aut_tras_store_id==="0"
                            || formContract.aut_tras_store_id===0
                            )? "noselect-button": "select-button" }`}
                            disabled={formContract.aut_tras_store_id===undefined
                            || formContract.aut_tras_store_id===""
                            || formContract.aut_tras_store_id==="0"
                            || formContract.aut_tras_store_id===0 } 
                            onClick={searchFormStoreNimaAddress}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>:
                        <IconButton  size="small" className="edit-noselect-button" disabled>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>
                    }
                </div>
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_INSCRIPTION')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="aut_tras_inscription" 
                        name="aut_tras_inscription"
                        value={formContract.aut_tras_inscription}
                        inputProps={{ style: {width:350,  fontSize: '18px'}, maxLength: 50 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}      
                        label={errorsForm.aut_tras_inscription!=null && errorsForm.aut_tras_inscription!==""?t(errorsForm.aut_tras_inscription):t('PlaceHolder_CONTRACT_INSCRIPTION')}
                        placeholder={t('PlaceHolder_CONTRACT_INSCRIPTION')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Aut_tras}
                        onChange={handleChangeDataEditContract_Aut_tras} 
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_OPT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;  
                    <TextField
                        id="aut_tras_opt"
                        name="aut_tras_opt"
                        value={ (formContract.aut_tras_opt === undefined || formContract.aut_tras_opt ===null || formContract.aut_tras_opt ===""
                            || formContract.aut_tras_opt ==="0" || formContract.aut_tras_opt ===0)?0:formContract.aut_tras_opt}
                        inputProps={{ style: {width: i18n.language==='es'?194:171,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}     
                        variant="outlined"
                        onBlur={handleBlurDataEditContract_Aut_tras}
                        onChange={handleChangeDataEditContract_Aut_tras} 
                        helperText={errorsForm.aut_tras_opt!=null?t(errorsForm.aut_tras_opt):""}
                            select
                        SelectProps={{
                            native: true,
                            value: (formContract.aut_tras_opt === undefined || formContract.aut_tras_opt ===null || formContract.aut_tras_opt ===""
                                || formContract.aut_tras_opt ==="0" || formContract.aut_tras_opt ===0)?0: formContract.aut_tras_opt
                        }}>
                        <option key={0} value=""/>
                        {optTypeToSelect.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.code} - {option.namees.substring(0,20)}
                        </option>
                        ))}
                    </TextField>            
                </div>
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_GESTOR')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="aut_tras_grnp" 
                        name="aut_tras_grnp"
                        value={formContract.aut_tras_grnp}
                        inputProps={{ style: {width: i18n.language==='es'?684:250, fontSize: '18px'}, maxLength: 50 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.aut_tras_grnp!=null && errorsForm.aut_tras_grnp!==""?t(errorsForm.aut_tras_grnp):t('PlaceHolder_CONTRACT_GESTOR')}
                        placeholder={t('PlaceHolder_CONTRACT_GESTOR')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Aut_tras}
                        onChange={handleChangeDataEditContract_Aut_tras} 
                    />
                    
                </div>
            </div>  
            <ContractSearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores}
                selectStores={"Aut_Tras"}
                setFormContract={setFormContract}
            />
            <ContractSearchStoresAddresses
                showModalSearchStoresAddress={showModalSearchStoresAddress}
                setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
                selectStores={"Aut_Tras"}
                setFormContract={setFormContract}
                titleTable={formContract.aut_tras_tradename}
                store_id={formContract.aut_tras_store_id}
                priority={3}
            />
            <ContractSearchStoresNimaAddresses
                showModalSearchStoresNimaAddress={showModalSearchStoresNimaAddress}
                setShowModalSearchStoresNimaAddress={setShowModalSearchStoresNimaAddress}
                selectStores={"Aut_Tras"}
                setFormContract={setFormContract}
                titleTable={formContract.aut_tras_tradename}
                store_id={formContract.aut_tras_store_id} 
            />
        </> 
    )
}

ContractCreateOrEditAutTras.propTypes = {
    formContract: PropTypes.object.isRequired,
    setFormContract: PropTypes.func.isRequired,
    setIsLoadingErrorData: PropTypes.func.isRequired,
    errorsForm: PropTypes.object.isRequired,
    setErrorsForm: PropTypes.func.isRequired,
    validateFormContract: PropTypes.func.isRequired,
    documentTypesToSelect: PropTypes.array.isRequired,
    roadTypesToSelect: PropTypes.array.isRequired,
    communityToSelect: PropTypes.array.isRequired,
    optTypeToSelect: PropTypes.array.isRequired
  };
  
  export default ContractCreateOrEditAutTras;
